/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_MessageInputs */

const en_admin_questionnaire_editor_message = /** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const de_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const es_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const it_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/** @type {(inputs: Admin_Questionnaire_Editor_MessageInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_message = en_admin_questionnaire_editor_message;

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Admin_Questionnaire_Editor_MessageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_message = /** @type {((inputs?: Admin_Questionnaire_Editor_MessageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_MessageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_message(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_message(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_message(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_message(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_message(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_message(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_message(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_message(inputs)
	return ro_admin_questionnaire_editor_message(inputs)
});
export { admin_questionnaire_editor_message as "admin.questionnaire_editor.message" }